import { SelectFilter } from './SelectFilter';

interface BooleanFilterProps {
  field: string;
  value: number | null;
  label: string;
  setValue: (value: number | null) => void;
  valueOnly?: boolean;
}

export const BooleanFilter: React.FC<BooleanFilterProps> = ({
  field,
  value,
  label,
  setValue,
  valueOnly,
}) => {
  return (
    <SelectFilter
      field={field}
      label={label}
      value={value}
      setValue={setValue}
      options={[
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 },
      ]}
      valueOnly={valueOnly}
    />
  );
};
